import PropTypes from 'prop-types';
import {
  createIntl as realCreateIntl,
  IntlProvider as RealIntlProvider,
} from 'react-intl/index';

export * from 'react-intl/index';

export const createIntl = (config = {}, cache) =>
  realCreateIntl(
    {
      defaultLocale: 'en',
      locale: 'en',
      messages: {},
      ...config,
    },
    cache
  );

export const intlShape = PropTypes.shape({
  formatDate: PropTypes.func,
  formatTime: PropTypes.func,
  formatRelative: PropTypes.func,
  formatNumber: PropTypes.func,
  formatPlural: PropTypes.func,
  formatMessage: PropTypes.func,
  now: PropTypes.func,
  locale: PropTypes.string,
});

export const addLocaleData = () => {};

if (RealIntlProvider) {
  RealIntlProvider.defaultProps = {
    ...RealIntlProvider.defaultProps,
    defaultLocale: 'en',
    locale: 'en',
    messages: {},
  };
}
